import LocationCountry from '../LocationCountry/LocationCountry';
import { SelectInputHelper } from '../selectInput/SelectInput';
import USStates from '../USStates/USStates';
import { t } from 'i18next';
import DealerSelection from '../USStates/DealerSelection';
import Province from '../Province/Province';
import { DealerAddressType, DealerStreetAddress } from '../CommonTypes';

export type DealerAddressLookupProps = {
    dealerAddress: DealerAddressType;
    onDealerAddressUpdated: (dealerAddress: DealerAddressType) => void;
};

const DealerAddressLookup = ({
    dealerAddress,
    onDealerAddressUpdated
}: DealerAddressLookupProps): JSX.Element => {
    const { locationCountry, stateOrProvince, dealerStreetAddressId } =
        dealerAddress || {};

    const onChangeLocationCountry = (selectedValue: string): void => {
        onDealerAddressUpdated({
            ...dealerAddress,
            locationCountry: selectedValue,
            dealerStreetAddressId: SelectInputHelper.NullValue(),
            dealerStreetAddress: null
        });
    };

    const onChangeState = (selectedValue: string): void => {
        onDealerAddressUpdated({
            ...dealerAddress,
            dealerStreetAddressId: SelectInputHelper.NullValue(),
            dealerStreetAddress: null,
            stateOrProvince: selectedValue
        });
    };

    const onChangeDealer = (
        selectedValue: string,
        dealerStreetAddress: DealerStreetAddress
    ): void => {
        onDealerAddressUpdated({
            ...dealerAddress,
            dealerStreetAddressId: selectedValue,
            dealerStreetAddress: dealerStreetAddress
        });
    };

    const onChangeProvince = (selectedValue: string): void => {
        onDealerAddressUpdated({
            ...dealerAddress,
            dealerStreetAddressId: SelectInputHelper.NullValue(),
            dealerStreetAddress: null,
            stateOrProvince: selectedValue
        });
    };

    const isUnitedStates = locationCountry === 'United States';
    const isCanada = locationCountry === 'Canada';

    return (
        <>
            <LocationCountry
                locationCountry={locationCountry}
                onChangeLocationCountry={onChangeLocationCountry}
            />
            {isUnitedStates && (
                <div className='dropdown-padding'>
                    <USStates
                        state={stateOrProvince}
                        onChangeState={onChangeState}
                    />
                </div>
            )}
            {locationCountry == 'Other' && (
                <div
                    className='alert alert-warning panel-selection-alert-container'
                    role='alert'>
                    {t('claim_not_covered_other')}
                </div>
            )}
            {isUnitedStates &&
                stateOrProvince !== SelectInputHelper.NullValue() && (
                    <div className='dropdown-padding'>
                        <DealerSelection
                            countryCode={locationCountry}
                            stateCode={stateOrProvince}
                            stateDealer={dealerStreetAddressId}
                            onChangeDealer={onChangeDealer}
                        />
                    </div>
                )}
            {isCanada && (
                <div className='dropdown-padding'>
                    <Province
                        province={stateOrProvince}
                        onChangeProvince={onChangeProvince}
                    />
                </div>
            )}
            {isCanada && stateOrProvince !== SelectInputHelper.NullValue() && (
                <div className='dropdown-padding'>
                    <DealerSelection
                        countryCode={locationCountry}
                        stateCode={stateOrProvince}
                        stateDealer={dealerStreetAddressId}
                        onChangeDealer={onChangeDealer}
                    />
                </div>
            )}
        </>
    );
};

export default DealerAddressLookup;
